import { render, staticRenderFns } from "./RoomImages.vue?vue&type=template&id=dc84290e&"
import script from "./RoomImages.vue?vue&type=script&lang=js&"
export * from "./RoomImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports